<div class="flex items-center justify-between mb-6">
  <h1 class="text-2xl font-bold">Mis ofertas</h1>
  <p-button
    label="Nueva oferta"
    icon="pi pi-plus"
    (onClick)="nuevaOferta()"
    styleClass="rounded-lg"
    type="button"
  />
</div>

<div class="grid grid-cols-1 gap-6 mb-6">
  <div class="bg-white rounded-xl shadow p-4 flex flex-col">
    <h2 class="text-lg font-medium mb-4">Ofertas por mes y tipo de tarifa</h2>
    <div class="flex-1">
      <p-chart
        type="bar"
        [data]="chartData()"
        [options]="chartOptions"
        class="h-full w-full"
      />
    </div>
  </div>

  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
    <p-card *ngFor="let c of resumen" class="shadow rounded-xl w-full">
      <div class="flex items-center gap-3">
        <i class="{{ c.icon }} text-2xl" [ngClass]="c.color"></i>
        <div>
          <p class="text-sm text-slate-500">{{ c.title }}</p>
          <p class="text-lg font-semibold">{{ c.value }}</p>
        </div>
      </div>
    </p-card>
  </div>
</div>

<div class="bg-white rounded-xl shadow p-4">
  <h2 class="text-lg font-medium mb-4">Últimas ofertas creadas</h2>

  @if (!loading()) {
    <p-table
      [value]="ofertas().slice(0, 10)"
      [tableStyle]="{ 'min-width': '900px' }"
      styleClass="shadow-sm rounded-xl overflow-hidden"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 120px">ID</th>
          <th>Cliente</th>
          <th>CUPS</th>
          <th>Compañía</th>
          <th>Tarifa</th>
          <th style="width: 160px">Creada</th>
          <th style="width: 220px" class="text-right">Acciones</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr (dblclick)="verDetalle(row)" class="cursor-pointer hover:bg-slate-50">
          <td class="font-medium">#{{ row.id }}</td>
          <td>{{ row.nombreCliente || '—' }}</td>
          <td>{{ row.cups || '—' }}</td>
          <td>{{ row.companiaActual || '—' }}</td>
          <td>
            <span class="px-2 py-1 rounded bg-slate-100">
              {{ row.tipoTarifa || '—' }}
            </span>
          </td>
          <td>{{ row.createdAt | date : 'short' }}</td>
          <td class="text-right">
            <p-button
              icon="pi pi-eye"
              (onClick)="verDetalle(row)"
              styleClass="p-button-text mr-1"
              type="button"
              pTooltip="Ver detalle"
            />
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center py-6 text-slate-500">
            No hay ofertas todavía
          </td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <div class="space-y-3">
      <p-skeleton height="44px" borderRadius="12px"/>
      <p-skeleton height="44px" borderRadius="12px"/>
      <p-skeleton height="44px" borderRadius="12px"/>
    </div>
  }
</div>
